export default __webpack_public_path__ + "static/media/grafema_ss-wedding-identity_05.604a39e1.jpg";